
import * as request from './useRequest'
export default (app) => app.mixin({ methods: { ...request, } })